// extracted by mini-css-extract-plugin
export default {"container":"MessageBox_container__RRkZu","txt-title":"MessageBox_txt-title__lXGln","txt-content":"MessageBox_txt-content__H+5qz","wrap-text-box":"MessageBox_wrap-text-box__KT1UA"};